var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "ia-container" }, [
    _c(
      "div",
      { staticClass: "ia-content" },
      [
        !_setup.hasPerformedSearch
          ? _c(_setup.SearchInfoHeaderComponent, {
              attrs: {
                title: _setup.TEXT.title,
                subtitle: _setup.TEXT.subtitle,
                icon: _setup.ICON.ia,
              },
            })
          : _vm._e(),
        _c(_setup.SearchIABoxQueryComponent, {
          on: { "new-query": _setup.handleNewQuery },
        }),
        _setup.showProgressBar
          ? _c(
              "div",
              { staticClass: "progress-bar-container" },
              [
                _c("div", { staticClass: "info-container" }, [
                  _c("div", { staticClass: "info-container-item" }, [
                    _c("span", { staticClass: "info-container-item-text" }, [
                      _vm._v(_vm._s(_setup.loadingText)),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-container-progress" }, [
                    _c("span", { staticClass: "progress-percentage" }, [
                      _vm._v(
                        _vm._s(Math.round(_setup.loadingProgress)) +
                          "% completado"
                      ),
                    ]),
                  ]),
                ]),
                _c("v-progress-linear", {
                  attrs: {
                    value: _setup.loadingProgress,
                    rounded: "",
                    color: "#59ac85",
                    "background-color": "#E0E0E0",
                    height: "8",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        !_setup.showProgressBar && _setup.hasSearchResults
          ? _c(_setup.SearchIAResultComponent, {
              attrs: { results: _setup.searchResults },
            })
          : !_setup.showProgressBar &&
            _setup.hasPerformedSearch &&
            !_setup.hasSearchResults
          ? _c(_setup.SearchIANoResultComponent)
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }